// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for the Admin page */

#admin-page {
    height: 100vh;

    display:flex;
    flex-direction: column;
}

#admin-layout {
    display: flex;
    justify-content: center;

    width: 100%;

    flex-grow: 1;

    background-color: #EAEAEA;
}

#admin-panels {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 25px;
    align-items: flex-start;
    justify-content: center;

    padding: 25px;

    width: 100%;
}

#main-admin {
    width: 50vw;
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: flex-start;
}

#table-area {
    flex-grow: 1;
}

#new-user-panel {
    min-width: 400px;
}

#create-user-button {
    visibility: hidden;
}

/* Do not display manage entity popup unless browser
   window is narrow */
#popup-background {
    visibility: hidden;
}

#main-admin .admin-button {
    background-color: #e4a343;
    color: white;

    border-style: none;
    border-radius: 10px;
}

#classcard-body {
    padding: 0;
}

#myclasslist {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#myclasslist {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#myclassitem {
    border-style: solid;
    border-width: 1px;
    border-color: #CCCCCC;
    border-radius: 10px;
  
    padding: 15px;
  
    min-width: 200px;
}

.edit-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.edit-info > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.edit-info > div > p {
    width: 8vw;

    flex-grow: 0;
}

.edit-info > div > input {
    flex-grow: 1;
}

#grade-dropdown {
    padding: 5px;
    width: 100%;
  
    /* Match other inputs on Admin: Create Class page */
    border-color: #CCCCCC;
    border-radius: 5px;
}

@media screen and (max-width: 1000px)
{
    #new-user-panel {
        display: none;
    }

    /* When the browser window is narrow, show create user button */
    #create-user-button {
        visibility: visible;
    }

    /* When the browser window is narrow, show manage user popup */
    #popup-background {
        visibility: visible;
    }

    #self-edit-disclaimer, #password-mismatch {
        max-width: 200px;
    }
}

#table-area {
    max-height: 100vh;
}

#scrollable-table {
    overflow-y: scroll;
    padding: 0;
    margin: 15px;
}

#table-utility {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;
}

#user-table {
    width: 100%;
}

#user-table th {
    background-color: #DC7699;
    color: white;
}

#user-table tr > * {
    padding: 10px;
}

#table-utility {
    position: sticky;
    top: 0;
    height: 60px;
    background-color: white;
}

#table-header {
    position: sticky;
    top: 60px;
}

.a-row {
    background-color: white;
}

.b-row {
    background-color: #F7EAEF;
}

.a-row:hover {
    background-color: #F5F5F5;
}

.b-row:hover {
    background-color: #F7DFE8;
}

#name-entry {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
}

#popup-background {
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
}

#new-user-popup {
    background-color: white;
    border-radius: 25px;
    margin: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    height: 85vh;
}

#new-user-header {
    background-color: var(--light-purple);
    color: white;
    width: 100%;
    padding: 25px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

#form-body {
    margin: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    overflow: hidden;
    overflow-y: scroll;
}

#form-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#new-user-submit {
    margin: 10px;
}

.item-group {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

#self-edit-disclaimer, #password-mismatch {
    color: red;
    max-width: 350px;
}

#loading-msg-area {
    z-index: 100;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: #ffffff80;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#loading-msg-area span {
    text-align: center;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/css/AdminPage.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,aAAa;;IAEb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;;IAEvB,WAAW;;IAEX,YAAY;;IAEZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,uBAAuB;;IAEvB,aAAa;;IAEb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;qBACqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;;IAEZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;;IAEnB,aAAa;;IAEb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;;IAEV,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,mDAAmD;IACnD,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA,+DAA+D;IAC/D;QACI,mBAAmB;IACvB;;IAEA,8DAA8D;IAC9D;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,MAAM;AACV;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;IACZ,2BAA2B;;IAE3B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":["/* Styling for the Admin page */\n\n#admin-page {\n    height: 100vh;\n\n    display:flex;\n    flex-direction: column;\n}\n\n#admin-layout {\n    display: flex;\n    justify-content: center;\n\n    width: 100%;\n\n    flex-grow: 1;\n\n    background-color: #EAEAEA;\n}\n\n#admin-panels {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 25px;\n    align-items: flex-start;\n    justify-content: center;\n\n    padding: 25px;\n\n    width: 100%;\n}\n\n#main-admin {\n    width: 50vw;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n    align-items: flex-start;\n}\n\n#table-area {\n    flex-grow: 1;\n}\n\n#new-user-panel {\n    min-width: 400px;\n}\n\n#create-user-button {\n    visibility: hidden;\n}\n\n/* Do not display manage entity popup unless browser\n   window is narrow */\n#popup-background {\n    visibility: hidden;\n}\n\n#main-admin .admin-button {\n    background-color: #e4a343;\n    color: white;\n\n    border-style: none;\n    border-radius: 10px;\n}\n\n#classcard-body {\n    padding: 0;\n}\n\n#myclasslist {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n#myclasslist {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n#myclassitem {\n    border-style: solid;\n    border-width: 1px;\n    border-color: #CCCCCC;\n    border-radius: 10px;\n  \n    padding: 15px;\n  \n    min-width: 200px;\n}\n\n.edit-info {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.edit-info > div {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n}\n\n.edit-info > div > p {\n    width: 8vw;\n\n    flex-grow: 0;\n}\n\n.edit-info > div > input {\n    flex-grow: 1;\n}\n\n#grade-dropdown {\n    padding: 5px;\n    width: 100%;\n  \n    /* Match other inputs on Admin: Create Class page */\n    border-color: #CCCCCC;\n    border-radius: 5px;\n}\n\n@media screen and (max-width: 1000px)\n{\n    #new-user-panel {\n        display: none;\n    }\n\n    /* When the browser window is narrow, show create user button */\n    #create-user-button {\n        visibility: visible;\n    }\n\n    /* When the browser window is narrow, show manage user popup */\n    #popup-background {\n        visibility: visible;\n    }\n\n    #self-edit-disclaimer, #password-mismatch {\n        max-width: 200px;\n    }\n}\n\n#table-area {\n    max-height: 100vh;\n}\n\n#scrollable-table {\n    overflow-y: scroll;\n    padding: 0;\n    margin: 15px;\n}\n\n#table-utility {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n#user-table {\n    width: 100%;\n}\n\n#user-table th {\n    background-color: #DC7699;\n    color: white;\n}\n\n#user-table tr > * {\n    padding: 10px;\n}\n\n#table-utility {\n    position: sticky;\n    top: 0;\n    height: 60px;\n    background-color: white;\n}\n\n#table-header {\n    position: sticky;\n    top: 60px;\n}\n\n.a-row {\n    background-color: white;\n}\n\n.b-row {\n    background-color: #F7EAEF;\n}\n\n.a-row:hover {\n    background-color: #F5F5F5;\n}\n\n.b-row:hover {\n    background-color: #F7DFE8;\n}\n\n#name-entry {\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n    align-items: center;\n}\n\n#popup-background {\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    top: 0;\n}\n\n#new-user-popup {\n    background-color: white;\n    border-radius: 25px;\n    margin: 100px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: hidden;\n    height: 85vh;\n}\n\n#new-user-header {\n    background-color: var(--light-purple);\n    color: white;\n    width: 100%;\n    padding: 25px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n#form-body {\n    margin: 25px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    overflow: hidden;\n    overflow-y: scroll;\n}\n\n#form-items {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n#new-user-submit {\n    margin: 10px;\n}\n\n.item-group {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n#self-edit-disclaimer, #password-mismatch {\n    color: red;\n    max-width: 350px;\n}\n\n#loading-msg-area {\n    z-index: 100;\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    background-color: #ffffff80;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n#loading-msg-area span {\n    text-align: center;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
